export default __webpack_public_path__ + "static/media/Rectangle.1e617fdc.svg";